<template>
  <section class="infoSection">
    <div class="container-fluid">
      <div class="wrap wrap-dark">
        <div class="row">
          <h2 class="col-12 infoSection__title h1">{{ item.partnersTitle }}</h2>
          <div class="col-12 infoSection__content infoSection__content-logos">
            <div class="row">
              <div class="col-6 col-lg-4 col-xl text-center partnerLogo" v-for="img in item.partnersImages" :key="img">
                <img :src="img" alt="partner">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'partnersSection',
   props: {
      item: {
        type: Object,
        required: true,
      },
    },
}
</script>

<style lang="less">
  .partnerLogo {
    margin: 3% 0 6%;

    img {
      max-width: 100%;
      max-height: 60px;
    }
  }
</style>
